(() => {
  if (!window.customElements || customElements.get('remass-back-in-stock')) return;

  const dialogId = 'RemassBackInStockDialog';

  const getDialog = () => {
    let dialog = document.getElementById(dialogId);
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.id = dialogId;
    dialog.className = 'remass-bis-dialog';
    dialog.setAttribute('aria-labelledby', `${dialogId}Title`);
    dialog.innerHTML = `
      <form class="remass-bis-dialog__form">
        <button type="button" class="remass-bis-dialog__close">&times;</button>
        <h2 id="${dialogId}Title"></h2>
        <p class="remass-bis-dialog__product"></p>
        <p class="remass-bis-dialog__intro"></p>
        <label class="remass-bis-dialog__variant-row">
          <span class="remass-bis-dialog__variant-label">sold-out option</span>
          <select class="remass-bis-dialog__variant" name="variant"></select>
        </label>
        <label>
          <span class="remass-bis-dialog__email-label">email</span>
          <input type="email" name="email" autocomplete="email" required>
        </label>
        <button type="submit" class="remass-bis-dialog__submit"></button>
        <p class="remass-bis-dialog__status" role="status" aria-live="polite"></p>
      </form>`;

    document.body.appendChild(dialog);
    dialog.querySelector('.remass-bis-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    return dialog;
  };

  class RemassBackInStock extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bisReady === 'true') return;
      this.dataset.bisReady = 'true';
      this.trigger = this.querySelector('.remass-bis-trigger');
      this.product = this.readProduct();
      this.trigger?.addEventListener('click', () => this.open());
    }

    readProduct() {
      try {
        return JSON.parse(this.querySelector('[data-remass-bis-product]')?.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    open() {
      const soldOutVariants = (this.product.variants || []).filter((variant) => !variant.available);
      if (!soldOutVariants.length) return;

      const dialog = getDialog();
      const form = dialog.querySelector('form');
      const variantRow = dialog.querySelector('.remass-bis-dialog__variant-row');
      const variantSelect = form.elements.variant;
      const emailInput = form.elements.email;
      const emailField = emailInput.closest('label');
      const submitButton = dialog.querySelector('.remass-bis-dialog__submit');
      const status = dialog.querySelector('.remass-bis-dialog__status');
      const session = Symbol('remass-bis-session');
      dialog.remassBisSession = session;

      dialog.querySelector('.remass-bis-dialog__close').setAttribute('aria-label', this.dataset.bisClose || 'close');
      dialog.querySelector(`#${dialogId}Title`).textContent = this.dataset.bisTitle || "notify me when it's back ♡";
      dialog.querySelector('.remass-bis-dialog__product').textContent = this.product.title || '';
      dialog.querySelector('.remass-bis-dialog__intro').textContent = this.dataset.bisIntro || '';
      dialog.querySelector('.remass-bis-dialog__email-label').textContent = this.dataset.bisEmailLabel || 'email';
      submitButton.textContent = this.dataset.bisSubmit || 'notify me ♡';

      variantSelect.replaceChildren(...soldOutVariants.map((variant) => {
        const option = new Option(variant.title || 'default', String(variant.id));
        return option;
      }));
      variantRow.hidden = soldOutVariants.length === 1;
      emailField.hidden = false;
      emailInput.hidden = false;
      emailInput.disabled = false;
      emailInput.value = '';
      submitButton.hidden = false;
      submitButton.disabled = false;
      status.textContent = '';

      form.onsubmit = async (event) => {
        event.preventDefault();
        const variantId = variantSelect.value;
        if (!variantId || !emailInput.reportValidity()) return;

        submitButton.disabled = true;
        status.textContent = this.dataset.bisSubmitting || 'submitting...';

        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: emailInput.value.trim() },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        };

        try {
          const response = await fetch(
            'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WQ8bfM',
            {
              method: 'POST',
              headers: {
                Accept: 'application/vnd.api+json',
                'Content-Type': 'application/vnd.api+json',
                revision: '2026-07-15',
              },
              body: JSON.stringify(payload),
            }
          );
          if (!response.ok) throw new Error('Subscription failed');
          if (dialog.remassBisSession !== session) return;

          status.textContent = this.dataset.bisSuccess || "yay! we'll let you know when it's back :)";
          emailField.hidden = true;
          emailInput.hidden = true;
          emailInput.disabled = true;
          submitButton.hidden = true;
        } catch (error) {
          if (dialog.remassBisSession !== session) return;
          status.textContent = this.dataset.bisError || 'something went wrong. please try again.';
          submitButton.disabled = false;
        }
      };

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      window.requestAnimationFrame(() => emailInput.focus());
    }
  }

  customElements.define('remass-back-in-stock', RemassBackInStock);
})();
